import React, { createContext, useState, useEffect } from 'react';
import { sseService } from '../services/sse';

export const ItensPedidosContext = createContext();

export function ItensPedidosProvider({ children }) {
  const [itenspedidos, setItensPedidos] = useState([]);
  const API_URL = process.env.REACT_APP_API_URL;

  const fetchItensPedidos = async () => {
    try {
      const token = localStorage.getItem('token');
      const estabelecimentoId = localStorage.getItem('estabelecimento_id');

      const headers = {
        'Content-Type': 'application/json'
      };

      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      // Admin pode ter mais de um estabelecimento — manda qual está
      // selecionado no painel pro backend não assumir o primeiro dele.
      const url = estabelecimentoId
        ? `${API_URL}/buscaitenspedido?estabelecimento_id=${estabelecimentoId}`
        : `${API_URL}/buscaitenspedido`;

      const response = await fetch(url, { headers });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const data = await response.json();
      console.log("Itens recebidos do servidor:", data);

      const itensServidor = Array.isArray(data) ? data : [];

      // Mesclar itens: manter itens do state que ainda não estão no servidor
      setItensPedidos((prevItens) => {
        const idsServidor = new Set(itensServidor.map(i => i.id_item));

        // Itens que ainda não estão no servidor (podem ter vindo via SSE)
        const itensNovos = prevItens.filter(i => !idsServidor.has(i.id_item));

        // Combinar
        const itensMesclados = [...itensNovos, ...itensServidor];

        console.log(`📦 Itens mesclados: ${itensNovos.length} novos + ${itensServidor.length} do servidor = ${itensMesclados.length} total`);

        return itensMesclados;
      });
    } catch (error) {
      console.error("Erro ao buscar itens pedidos:", error);
    }
  };

  const atualizarItens = async () => {
    console.log('🔄 Atualizando itens dos pedidos...');
    await fetchItensPedidos();
  };

  useEffect(() => {
    fetchItensPedidos();

    // 📢 Listener para recarregar itens após login
    const handleLoginSuccess = () => {
      console.log('📢 [ItensPedidosContext] Evento loginSuccess recebido, recarregando itens...');
      fetchItensPedidos();
    };

    // 🔔 Handler para novos pedidos via SSE - adiciona os itens
    const handleNovoPedido = (data) => {
      const novoPedido = data.pedido;
      const clienteId = localStorage.getItem('id_cliente');

      // Se for cliente, verificar se é pedido dele
      if (clienteId && String(novoPedido.id_cliente) !== clienteId) {
        return;
      }

      // Adicionar itens do novo pedido
      if (novoPedido.itens && Array.isArray(novoPedido.itens)) {
        console.log('🔔 [ItensPedidosContext] Adicionando itens do novo pedido:', novoPedido.itens.length);
        setItensPedidos((prevItens) => {
          const novosItens = novoPedido.itens.filter(
            novoItem => !prevItens.some(i => i.id_item === novoItem.id_item)
          );
          return [...novosItens, ...prevItens];
        });
      }
    };

    window.addEventListener('loginSuccess', handleLoginSuccess);
    sseService.on('novo_pedido', handleNovoPedido);

    // Limpar listeners ao desmontar
    return () => {
      window.removeEventListener('loginSuccess', handleLoginSuccess);
      sseService.off('novo_pedido', handleNovoPedido);
    };
  }, []);

  return (
    <ItensPedidosContext.Provider value={{ itens_do_pedido: itenspedidos, atualizarItens }}>
      {children}
    </ItensPedidosContext.Provider>
  );
}
